<template>
  <div>
    <div v-for="(item,index) in imageList" key="sceneMaterialImageAdding">
      <scene-material-image-adding :imageInfo="item" @addMaterialImageFinish="addMaterialImageFinish"></scene-material-image-adding>
    </div>
  </div>
</template>

<script>
import SceneMaterialImageAdding from "@/views/globe/globe_marker/SceneMaterialImage_adding";

export default {
  name: "SceneMaterialImageEntryAdding",
  components: {SceneMaterialImageAdding},
  props:['imageList'],
  methods:{
    addMaterialImageFinish(currMaterialImageInfo){
      console.log("SceneMaterialImageEntryAdding")
      this.$emit("addMaterialImageFinish",currMaterialImageInfo)
    },
  },
  mounted(){
    console.log(this.imageList)

  }
}
</script>

<style scoped>

</style>